const colors = {
    brandPurple: {
        100: "#E6D6FF",
        200: "#CBA6FF",
        300: "#AD7DFF",
        400: "#944FFF",
        500: "#8732F4",
        600: "#7314D7",
        700: "#5D0FB1",
        800: "#460A88",
        900: "#2E065D"
    },
    violetPurple: {
        100: "#ECDDFE",
        200: "#D6B9FC",
        300: "#BD93FB",
        400: "#A36AF9",
        500: "#7F3FFF",
        600: "#6629E0",
        700: "#4E1FB5",
        800: "#36158A",
        900: "#240F5C"
    },
    appBackground: {
        100: "#E3E3E3",
        200: "#C6C6C6",
        300: "#A9A9A9",
        400: "#8C8C8C",
        500: "#1A1B1C",
        600: "#151617",
        700: "#101111",
        800: "#0A0B0B",
        900: "#050505"
    },
    loginInputsBackground: {
        100: "#ECEDED",
        200: "#D8D9DA",
        300: "#C4C5C6",
        400: "#AEB0B2",
        500: "#232627",
        600: "#1C1F20",
        700: "#151718",
        800: "#0D0F0F",
        900: "#070808"
    },
    loginInputsText: {
        100: "#ECEDED",
        200: "#D6D7D8",
        300: "#C1C2C4",
        400: "#ABADAF",
        500: "#B5B8BA",
        600: "#9FA2A4",
        700: "#898C8E",
        800: "#737576",
        900: "#5E6061"
    },
    success: {
        100: "#D5FBE8",
        200: "#AAF7D1",
        300: "#7FF3BA",
        400: "#54EFA3",
        500: "#3FDD78",
        600: "#30B964",
        700: "#239651",
        800: "#16723D",
        900: "#094E29"
    },
    lavenderMist: {
        100: "#F1E8FF",
        200: "#E3D1FF",
        300: "#D6B9FF",
        400: "#C8A2FF",
        500: "#CBA6FF",
        600: "#A984D9",
        700: "#8663B3",
        800: "#64428D",
        900: "#412066"
    },
    slateGray: {
        100: "#DDE1E5",
        200: "#BCC3CA",
        300: "#9CA6AF",
        400: "#7B8894",
        500: "#4A5568",
        600: "#3A4453",
        700: "#2B343E",
        800: "#1B2329",
        900: "#0C1214"
    },
    ashenGray: {
        100: "#E3E5E6",
        200: "#C7CACB",
        300: "#ACB0B1",
        400: "#909596",
        500: "#6C7275",
        600: "#585D5F",
        700: "#444849",
        800: "#303233",
        900: "#1C1D1E"
    },
    burntCinnamon: {
        100: "#F7E5D9",
        200: "#EECBAD",
        300: "#E4A980",
        400: "#DB874F",
        500: "#8F4D11",
        600: "#733E0E",
        700: "#582F0B",
        800: "#3D2007",
        900: "#211003"
    },
    sunsetAmber: {
        100: "#FDEBD7",
        200: "#FBD6AE",
        300: "#F9C286",
        400: "#F7AD5D",
        500: "#ED9340",
        600: "#C57835",
        700: "#9C5E2A",
        800: "#74441F",
        900: "#4B2A14"
    },
    ironGray: {
        100: "#E3E3E3",
        200: "#C6C6C6",
        300: "#AAAAAA",
        400: "#8D8D8D",
        500: "#5B5B5B",
        600: "#494949",
        700: "#373737",
        800: "#242424",
        900: "#121212"
    },
    royalViolet: {
        100: "#ECDFFD",
        200: "#D7B8FA",
        300: "#C291F8",
        400: "#AC6AF6",
        500: "#6B28C8",
        600: "#571FA0",
        700: "#421678",
        800: "#2D0D50",
        900: "#190428"
    },
    bloodCrimson: {
        100: "#FBD5DB",
        200: "#F7ABB6",
        300: "#F38091",
        400: "#EF566C",
        500: "#AD0725",
        600: "#8A061E",
        700: "#670417",
        800: "#430310",
        900: "#200108"
    },
    violetMist: {
        100: "#EBE4FB",
        200: "#D6C9F7",
        300: "#C1AEF3",
        400: "#AC93EF",
        500: "#805BD5",
        600: "#6749AA",
        700: "#4E3780",
        800: "#352555",
        900: "#1B132B"
    },
    onyxBlack: {
        100: "#CCCCCC",
        200: "#999999",
        300: "#666666",
        400: "#333333",
        500: "#282828",
        600: "#202020",
        700: "#181818",
        800: "#101010",
        900: "#080808"
    },
    n: {
        100: "#FEFEFE",
        200: "#F3F5F7",
        300: "#E8ECEF",
        400: "#6C7275",
        500: "#343839",
        600: "#232627",
        700: "#141718",
        800: "#050809",
        900: "#000000"
    },
};

export default colors;
